import { Star } from "lucide-react";

interface TestimonialCardProps {
  quote: string;
  name: string;
  role?: string;
  showStars?: boolean;
}

/**
 * Standalone testimonial card for use in grids or sliders.
 * Pairs with ContentSection or standalone layouts.
 */
const TestimonialCard = ({ quote, name, role, showStars = true }: TestimonialCardProps) => {
  return (
    <div className="bg-card border border-border p-6 md:p-8 flex flex-col h-full transition-colors hover:border-accent/30">
      {showStars && (
        <div className="flex gap-0.5 mb-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="w-4 h-4 text-accent fill-accent" strokeWidth={1} />
          ))}
        </div>
      )}
      <p className="text-muted-foreground text-sm md:text-base leading-relaxed flex-1 mb-5">
        &ldquo;{quote}&rdquo;
      </p>
      <div>
        <p className="font-headline text-base text-foreground font-semibold">{name}</p>
        {role && (
          <p className="font-body text-xs text-muted-foreground mt-0.5">{role}</p>
        )}
      </div>
    </div>
  );
};

export default TestimonialCard;
